import { useQuery } from '@tanstack/react-query';
import { useRestaurant } from '../../../context/useRestaurant';
import {
  getReservationActivities,
  type ReservationActivity,
} from '../apiHelpers';

export const useFetchReservationActivities = (reservationId: string | null) => {
  const { id: restaurantId } = useRestaurant();

  return useQuery<ReservationActivity[]>({
    queryKey: [
      'restaurants',
      restaurantId,
      'reservations',
      reservationId,
      'activities',
    ],
    queryFn: async () => {
      if (!reservationId) return [];
      return getReservationActivities(restaurantId, reservationId);
    },
    throwOnError: true,
    enabled: reservationId !== null,
  });
};
